/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Provenance of the most-recent applied observation. "manual" is intentionally absent — admin overrides flow through PresenceOverride.
 * @export
 */
export const LiveSource = {
    EVENT: 'EVENT',
    POLL: 'POLL'
} as const;
export type LiveSource = typeof LiveSource[keyof typeof LiveSource];


export function instanceOfLiveSource(value: any): boolean {
    for (const key in LiveSource) {
        if (Object.prototype.hasOwnProperty.call(LiveSource, key)) {
            if (LiveSource[key as keyof typeof LiveSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LiveSourceFromJSON(json: any): LiveSource {
    return LiveSourceFromJSONTyped(json, false);
}

export function LiveSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveSource {
    return json as LiveSource;
}

export function LiveSourceToJSON(value?: LiveSource | null): any {
    return value as any;
}

export function LiveSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): LiveSource {
    return value as LiveSource;
}

